import Axios from 'axios';
import { LOGIN_USER, SET_LOGIN_DATA, LOGIN_SERVER_ERROR, ERROR, FORGOT_PASSWORD, SET_LOGIN_ERRORS, START_LOADING } from './types';
import { API_URL } from "../constants";
import globalAxios from '../util/Api';
import { GetSystemPdf } from '../container/Systems/SystemsAction';

export const LoginAction = (username, password) => {
  return (dispath) => {
    dispath({
      type: START_LOADING,
    })
    return Axios.post(API_URL + '/auth/sign_in', {
      login: username,
      password: password
    })
      .then((resp) => {
        localStorage.setItem("user", JSON.stringify(resp.data.data))
        localStorage.setItem("is_logged_in", true)
        localStorage.setItem("access-token", resp.headers["access-token"]);
        localStorage.setItem("client", resp.headers["client"]);
        localStorage.setItem("uid", resp.headers["uid"]);
        localStorage.setItem("access_right", JSON.stringify(resp.data.access_right));
        document.cookie = "mycookie=1"
        if (!localStorage.getItem("is_first_login")) {
          localStorage.setItem("is_first_login", resp.data.data["is_first_login"]);
        }
        if (resp.data.data["is_first_login"]) {
          dispath(GetSystemPdf())
        }
        document.cookie = `lipro_uid=${resp.headers["uid"]}`;
        dispath({
          type: LOGIN_USER,
          payload: resp.data.data
        })
      })
      .catch(err => {
        dispath({
          type: LOGIN_SERVER_ERROR,
          payload: {
            has_error: true, status: err.response.status,
            status_text: err.response.statusText, message: err.response.data.errors[0]
          }
        })
      });

  }
}

export const ForgotPasswordAction = (email) => {
  return (dispatch) => {
    dispatch({
      type: START_LOADING,
    })
    return globalAxios().post(API_URL + `/auth/password?email=${email}&redirect_url=http://lipro.piramide.de/auth/password/edit`).then(res => {
      if (res) {
        dispatch({ type: FORGOT_PASSWORD, payload: res.data.message })
      }
    })
      .catch(err => {
        if (err.response)
          dispatch({
            type: ERROR,
            payload: err.response.data.errors
          })
      });
  }
}

export const SetNewPassword = (password, confirmPassword) => {
  let bodyFormData = new FormData();
  const params = new URLSearchParams(window.location.search)
  const reset_password_token = params.get('reset_password_token')
  bodyFormData.append('password', password);
  bodyFormData.append('password_confirmation', confirmPassword);
  bodyFormData.append('reset_password_token', reset_password_token);
  return (dispatch) => {
    dispatch({
      type: START_LOADING,
    })
    return Axios.put(API_URL + `/auth/password`, bodyFormData).then(res => {
      if (res) {
        dispatch({ type: FORGOT_PASSWORD, payload: res.data.message })
      }
    })
      .catch(err => {
        if (err.response)
          dispatch({
            type: ERROR,
            payload: err.response.data.errors
          })
      });
  }
}

export const OnFirstLoginChange = (id) => {
  let bodyFormData = new FormData();
  bodyFormData.append('user[is_first_login]', false);
  return (dispatch) => {
    return globalAxios().put(API_URL + `/api/v1/update_first_login?id=${id}`, bodyFormData).then(res => {
      if (res) {
        localStorage.setItem("is_first_login", false);
        dispatch({ type: LOGIN_USER, payload: res.data.users })
      }
    })
    //   .catch(err => {
    //   dispath({
    //     type: LOGIN_SERVER_ERROR,
    //     payload: {
    //       has_error: true, status: err.response.status,
    //       status_text: err.response.statusText, message: err.response.data.errors[0]
    //     }
    //   })
    // });
  }
}

export const LoginOnChange = (event) => {
  return {
    type: SET_LOGIN_DATA,
    payload: { key: event.target.id, value: event.target.value }

  }
}

export const LoginSetErrors = (key, value) => {
  return {
    type: SET_LOGIN_ERRORS,
    payload: { key: key, value: value }
  }
}